import { useEffect, useState, useCallback, useRef } from "react";
import {
  CaretDownOutlined,
  WarningOutlined,
  DownOutlined,
} from "@ant-design/icons";
// import { RangeStepInput } from 'react-range-step-input';
// import FileSaver from "file-saver";

import {
  ArrowLeftOutlined,
  SwapOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { DatePicker } from "antd";
// import { useHistory } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  Card,
  Space,
  Slider,
  Input,
  Button,
  Dropdown,
  Tooltip as tooltip,
} from "antd";
import { Select } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import download from "../assets/images/download.svg";
// import { useCurrentPng } from "recharts-to-png";
// import dayjs from "dayjs";
import { makeDisabledDatePastNDays } from "../utils/dateLimits";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Label,
  Tooltip,
  LineChart,
  Legend,
  ResponsiveContainer,
  ReferenceArea,
  AreaChart,
  Area,
  ReferenceLine,
} from "recharts";
import { Spin } from "antd";
import { get, post } from "../Libraries/Ajax/HttpService";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
// import * as htmlToImage from 'html-to-image';
import * as htmlToImage from "dom-to-image-more";
import back from "../assets/images/back.svg";
import { useDistrict } from "../utils/DistrictContext";

function TotalFlow() {
  const controller = new AbortController();
  const signal = controller.signal;
  const [defaultOption, setDefaultOption] = useState("Past Month");
  const domEl = useRef(null);
  const { Option } = Select;
  const [optionone, setOptionone] = useState(["total"]);
  const [optiononenew, setOptiononenew] = useState(["Days"]);
  const [classcodepotablesupply, setClasscodepotablesupply] = useState(["ALL"]);
  const [classcodepotabledemand, setClasscodepotabledemand] = useState(["ALL"]);
  const [classcodetotalsupply, setClasscodetotalsupply] = useState(["ALL"]);
  const [classcodetotaldemand, setClasscodetotaldemand] = useState(["ALL"]);
  const [list, setList] = useState([]);
  const [account, setAccount] = useState(null);
  const [accounts, setAccounts] = useState(null);
  const [listOfUsers, setListofUsers] = useState([]);
  const [parameterone, setParameterone] = useState();
  const [parametertwo, setParametertwo] = useState();
  const [arrayData, setArrayData] = useState(null);
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [demand, setDemand] = useState(false);
  const [Produced, setProduced] = useState(false);
  const [status, setStatus] = useState(true);
  const [supply, setSupply] = useState(false);
  const [prediction, setPrediction] = useState(false);
  const [accountability, setAccountability] = useState(true);
  const [name, setName] = useState("Accountability");
  const [slvalue, setSlvalue] = useState(1);
  const [value, setvalue] = useState(1);
  const [color, setColor] = useState([]);
  const [launchDate, setLaunchDate] = useState("");
  const [datapredictions, setDatapredictions] = useState(null);
  const [datastatusaccontability, setDatastatusaccountability] =
    useState(false);
  const [datastatusanomaly, setDatastatusanomaly] = useState(false);
  const arryDatas = [];
  const accountNew = [];
  const accountNews = [];
  const type = "linear";
  const dataPrediction = [];
  const [percentage, setPercentage] = useState("");
  const { RangePicker } = DatePicker;
  const selectedDistrict = useDistrict();
  const navigate = useNavigate();
  const districtId = selectedDistrict?.selectedDistrict;
  const isFB151 = districtId === "FB151";
  // Disable any day >= (today - 2 days)
  const disabledDate = makeDisabledDatePastNDays(2);

  //   const disabledDate = (current) => {
  //   if (!current) return false;
  //   const cutoffDay = dayjs().subtract(2, "day").startOf("day");
  //   return current.isAfter(cutoffDay, "day") || current.isSame(cutoffDay, "day");
  //   };

  const downloadImage = async () => {
    const el = domEl.current;
    if (!el) {
      toast.error("Target element not found");
      return;
    }

    // Get actual dimensions
    const rect = el.getBoundingClientRect();
    const width = Math.ceil(rect.width);
    const height = Math.ceil(rect.height);

    try {
      const dataUrl = await htmlToImage.toPng(el, {
        width,
        height,
        cacheBust: true,
        backgroundColor: "white",
        style: {
          width: `${width}px`,
          height: `${height}px`,
          overflow: "visible",
          transform: "none",
          display: "block",
        },
      });

      const link = document.createElement("a");
      link.download = `${name}-${optionone}-${defaultOption}-${JSON.parse(
        localStorage.getItem("MCData"),
      )?.selectedDistrict?.toString()}.png`;
      link.href = dataUrl;
      document.body.appendChild(link); // Required for Firefox
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Failed to export image:", err);
      toast.error("Failed to download image.");
    }
  };
  //    useEffect(() => {
  //     const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //     document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //   }, []);

  useEffect(() => {
    if (
      defaultOption === "Past Month" ||
      defaultOption === "Past 3 Months" ||
      defaultOption === "Past Year"
    ) {
      setOptiononenew("Weeks");
    }
  }, [defaultOption]);

  useEffect(
    () => {
      var user = JSON.parse(localStorage.getItem("MCData"));
      var userid = user?.userid;

      get(`apis/alert_status?user_id=${userid}`).then((response) => {
        console.log(response.data.data.accountability_alert_status);
        setDatastatusaccountability(
          response.data.data.accountability_alert_status,
        );
        setDatastatusanomaly(response.data.data.anomaly_alert_status);
      });
    },
    [datastatusaccontability],
    [datastatusanomaly],
    [selectedDistrict],
  );
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;

    if (datastatusaccontability === true) {
      post(
        `apis/alert_status_change?user_id=${userid}&accountability_seen=true`,
      ).then((response) => {});
    }
  });
  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("MCData"));
    var userid = user?.userid;
    get(`apis/user_color?user_id=${userid}&page=total`).then((response) => {
      console.log(response.data.color);
      setColor(response.data.color);
    });
  }, []);
  const onchange = (value, dateString) => {
    setParameterone(dateString[0]);
    setParametertwo(dateString[1]);
    setvalue(
      Math.floor(
        (new Date(parametertwo) - new Date(parameterone)) /
          (1000 * 60 * 60 * 24) /
          7,
      ),
    );
  };
  const toPercent = (decimal, fixed = 0) =>
    `${Number.parseInt(decimal * 100)}%`;

  const getPercent = (value, total) => {
    const ratio = total > 0 ? (value / total).toFixed(2) : 0;

    return toPercent(ratio, 2);
  };

  const renderTooltipContent = (o) => {
    const { payload, label } = o;
    if (payload && label) {
      const total = payload?.reduce((result, entry) => result + entry.value, 0);
      const sorted = payload.sort((a, b) => (a.value < b.value ? 1 : -1));
      console.log("sorted--", sorted);
      if (sorted && sorted.length) {
        return (
          <div className="custom-tooltip">
            <p className="total">
              {/* {`${label} (Total: ${total.toFixed(2)})`} */}
              {`${label} (Total: ${total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })})`}
            </p>
            <ul className="list">
              {sorted.map((entry, index) => (
                <li key={`item-${index}`} style={{ color: entry.color }}>
                  {/* {`${entry.name}: ${entry.value}(${getPercent(entry.value, total)})`} */}
                  {`${entry.name}: ${entry.value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })} (${getPercent(entry.value, total)})`}
                </li>
              ))}
            </ul>
          </div>
        );
      }
    }
    return null;
  };
  const items = [
    {
      label: (
        <a href="#" onClick={downloadImage}>
          Download As PNG
        </a>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <button className="csvlink">
          <CSVLink
            data={listOfUsers}
            filename={
              optionone.toString() +
              "-" +
              defaultOption.toString() +
              "-" +
              JSON.parse(
                localStorage.getItem("MCData"),
              )?.selectedDistrict?.toString()
            }
          >
            Download As CSV
          </CSVLink>
        </button>
      ),

      key: "1",
    },
  ];
  useEffect(() => {
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined &&
      Produced == true
    ) {
      setLoading(true);
      get(
        `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
      ).then((response) => {
        console.log(response);
        setListofUsers(response.data);
        // console.log("aaaaaaaaa", listOfUsers);
      });
      get(
        `apis/total_flow_produced?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
        {
          signal: signal,
        },
      )
        .then((res) => {
          setResponse(res.data.data);
          setList(response.code_list);
          setStatus(res.data.data.all);
          setArrayData(null);
          setAccount(null);
          // res.data.data.total_flow.map((x, i) => {
          //    let Obj = {
          //         name: x[0]?.flow_date,
          //         optionnew: x[0]?.option,
          //         value: x[0]?.flow,
          //         option: x[0]?.option_month,

          //     };

          //     arryDatas.push(Obj);

          //      });
          res.data.data.total_flow.forEach((entry) => {
            const obj = {
              name: entry[0]?.flow_date,
              optionnew: entry[0]?.option,
              option: entry[0]?.option_month,
            };

            entry.forEach((item) => {
              obj[item.code] = item.flow;
            });

            arryDatas.push(obj);
          });
          setArrayData(arryDatas);
          setLoading(false);
        })
        .catch((err) => {
          if (err.name === "AbortError") {
            console.log("successfully aborted");
          }
        });
      return () => {
        controller.abort();
      };
    } else {
      if (
        defaultOption != "Custom" &&
        parameterone == null &&
        parametertwo == null &&
        Produced == true
      ) {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          // console.log("aaaaaaaaa", listOfUsers);
        });
        get(
          `apis/total_flow_produced?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,

          {
            signal: signal,
          },
        )
          .then((res) => {
            setArrayData(null);
            setAccount(null);
            setResponse(res.data.data);
            setList(response.code_list);
            setStatus(res.data.data.all);
            // res.data.data.total_flow.map((x, i) => {
            //     let Obj = {
            //         name: x[0]?.flow_date,
            //         optionnew: x[0]?.option,
            //         value: x[0]?.flow,
            //         option: x[0]?.option_month,

            //     };

            //     arryDatas.push(Obj);
            //   });
            res.data.data.total_flow.forEach((entry) => {
              const obj = {
                name: entry[0]?.flow_date,
                optionnew: entry[0]?.option,
                option: entry[0]?.option_month,
              };

              entry.forEach((item) => {
                obj[item.code] = item.flow;
              });

              arryDatas.push(obj);
            });
            setArrayData(arryDatas);
            console.log("produced", arryDatas);
            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          controller.abort();
        };
      }
    }
  }, [
    Produced,
    optionone,
    defaultOption,
    optiononenew,
    slvalue,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);
  useEffect(() => {
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined &&
      supply == true
    ) {
      if (optionone == "potable") {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaca", listOfUsers);
        });
        get(
          `apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            console.log("new----------------nation-------------");

            setList(response.code_list);
            setArrayData(null);
            setAccount(null);

            setStatus(res.data.data.all);

            console.log("status", status);

            res.data.data.total_flow.map((x, i) => {
              let Obj = {
                name: x[0]?.flow_date,
                optionnew: x[0]?.option,
                value: x[0]?.flow,
                option: x[0]?.option_month,
              };

              arryDatas.push(Obj);
            });
            setArrayData(arryDatas);

            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          controller.abort();
        };
      } else if (optionone == "total") {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaa----", listOfUsers);
        });
        get(
          `apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            setList(response.code_list);
            setArrayData(null);
            setAccount(null);
            setArrayData(null);
            setAccount(null);
            setStatus(res.data.data.all);
            console.log("status", status);
            res.data.data.code_list.map((x, index) => {
              console.log(x);
              var a = "#";

              let Obj = {
                name: isFB151 ? x.code_name : x,
                colour: color[index],
              };
              accountNew.push(Obj);
              setAccount(accountNew);
            });
            console.log(account);

            res.data.data.total_flow.map((x, i) => {
              console.log("------yty--------", x);
              if (isFB151) {
                let name = x[0]?.flow_date;
                let optionnew = x[0]?.option;
                let option = x[0]?.option_month;
                const meterData = Object.fromEntries(
                  x?.map(({ code_name, flow }) => [code_name, flow]),
                );

                const weeklyMeterData = {
                  name,
                  optionnew,
                  option,
                  ...meterData,
                };

                arryDatas.push(weeklyMeterData);
                console.log(weeklyMeterData);
              } else if (classcodetotalsupply == "ALL" && !isFB151) {
                const item = x[0];
                let Obj = {
                  name: item?.flow_date,
                  optionnew: item?.option,
                  option: item?.option_month,
                  // [item.code]: item?.flow,
                  value: item?.flow,
                };
                arryDatas.push(Obj);
                console.log("DISTB", arryDatas);
              }
            });
            setArrayData(arryDatas);
            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          controller.abort();
        };
      } else {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaa", listOfUsers);
        });
        get(
          `apis/total_flow_supply?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            setList(response.code_list);
            setArrayData(null);
            setAccount(null);
            setStatus(res.data.data.all);
            console.log("status", status);
            // res.data.data.total_flow.map((x, i) => {
            //     console.log(x);

            //     let Obj = {
            //         name: x[0]?.flow_date,
            //         optionnew: x[0]?.option,
            //         value: x[0]?.flow,
            //         option: x[0]?.option_month,

            //     };

            //     arryDatas.push(Obj);

            //   });
            res.data.data.total_flow.forEach((entry) => {
              const obj = {
                name: entry[0]?.flow_date,
                optionnew: entry[0]?.option,
                option: entry[0]?.option_month,
              };

              entry.forEach((item) => {
                obj[item.account_name] = item.flow;
              });

              arryDatas.push(obj);
            });
            setArrayData(arryDatas);
            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          // cancel the request before component unmounts

          controller.abort();
        };
      }
    } else {
      if (
        defaultOption != "Custom" &&
        parameterone == null &&
        parametertwo == null &&
        supply == true
      ) {
        if (optionone == "potable") {
          setLoading(true);
          get(
            `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`,
          ).then((response) => {
            console.log(response);
            setListofUsers(response.data);
            console.log("aaaaaaaaa", listOfUsers);
          });
          get(
            `apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotablesupply}`,

            {
              signal: signal,
            },
          )
            .then((res) => {
              setResponse(res.data.data);
              setList(response.code_list);
              setArrayData(null);
              setAccount(null);

              setStatus(res.data.data.all);

              console.log("status", status);
              res.data.data.total_flow.map((x, i) => {
                console.log(x);

                let Obj = {
                  name: x[0]?.flow_date,
                  optionnew: x[0]?.option,
                  value: x[0]?.flow,
                  option: x[0]?.option_month,
                };

                arryDatas.push(Obj);
              });
              setArrayData(arryDatas);
              setLoading(false);
            })
            .catch((err) => {
              if (err.name === "AbortError") {
                console.log("successfully aborted");
              }
            });
          return () => {
            controller.abort();
          };
        } else if (optionone == "total") {
          setLoading(true);
          get(
            `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`,
          ).then((response) => {
            console.log(response);
            setListofUsers(response.data);
            console.log("aaaaaaaaa", listOfUsers);
          });
          get(
            `apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotalsupply}`,

            {
              signal: signal,
            },
          )
            .then((res) => {
              //   console.log(res.data.data.total_flow);

              setResponse(res.data.data);
              setList(response.code_list);
              setArrayData(null);
              setAccount(null);
              setStatus(res.data.data.all);
              if (
                res?.data?.data?.message &&
                res?.data?.data?.message.trim() !== ""
              ) {
                toast.info(res.data.data.message);
              }
              console.log("status", status);

              res.data.data.code_list.map((x, index) => {
                console.log(x);
                var a = "#";

                let Obj = {
                  name: isFB151 ? x.code_name : x,

                  colour: color[index],
                };
                accountNew.push(Obj);
                setAccount(accountNew);
              });
              console.log(account);
              res.data.data.total_flow.map((x, i) => {
                if (isFB151) {
                  let name = x[0]?.flow_date;
                  let optionnew = x[0]?.option;
                  let option = x[0]?.option_month;
                  const meterData = Object.fromEntries(
                    x?.map(({ code_name, flow }) => [code_name, flow]),
                  );

                  const weeklyMeterData = {
                    name,
                    optionnew,
                    option,
                    ...meterData,
                  };

                  arryDatas.push(weeklyMeterData);
                  console.log(weeklyMeterData);
                } else if (classcodetotalsupply == "ALL" && !isFB151) {
                  const item = x[0];
                  let Obj = {
                    name: item?.flow_date,
                    optionnew: item?.option,
                    option: item?.option_month,
                    // [item.code]: item?.flow,
                    value: item?.flow,
                  };
                  arryDatas.push(Obj);
                  console.log("DISTB", arryDatas);
                }
              });
              setArrayData(arryDatas);

              setLoading(false);
            })
            .catch((err) => {
              if (err.name === "AbortError") {
                console.log("successfully aborted");
              }
            });
          return () => {
            // cancel the request before component unmounts

            controller.abort();
          };
        } else {
          setLoading(true);
          get(
            `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
          ).then((response) => {
            console.log(response);
            setListofUsers(response.data);
            console.log("aaaaaaaaa", listOfUsers);
          });
          get(
            `apis/total_flow_supply?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,

            {
              signal: signal,
            },
          )
            .then((res) => {
              setResponse(res.data.data);
              setList(response.code_list);
              setArrayData(null);
              setAccount(null);
              setStatus(res.data.data.all);
              console.log("status", status);
              // res.data.data.total_flow.map((x, i) => {
              //     let Obj = {
              //         name: x[0]?.flow_date,
              //         optionnew: x[0]?.option,
              //         value: x[0]?.flow,
              //         option: x[0]?.option_month,

              //     };

              //     arryDatas.push(Obj);

              //     });
              res.data.data.total_flow.forEach((entry) => {
                const obj = {
                  name: entry[0]?.flow_date,
                  optionnew: entry[0]?.option,
                  option: entry[0]?.option_month,
                };

                entry.forEach((item) => {
                  obj[item.account_name] = item.flow;
                });

                arryDatas.push(obj);
              });
              setArrayData(arryDatas);
              console.log("supply-non-potable", arryDatas);
              setArrayData(arryDatas);
              setLoading(false);
            })
            .catch((err) => {
              if (err.name === "AbortError") {
                console.log("successfully aborted");
              }
            });
          return () => {
            // cancel the request before component unmounts

            controller.abort();
          };
        }
      }
    }
  }, [
    supply,
    optionone,
    defaultOption,
    optiononenew,
    slvalue,
    classcodetotalsupply,
    classcodepotablesupply,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);

  useEffect(() => {
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined &&
      accountability == true
    ) {
      setLoading(true);
      get(
        `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
      ).then((response) => {
        console.log(response);
        setListofUsers(response.data);
        console.log("aaaaaaaaa", listOfUsers);
      });
      get(
        `apis/accountability?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
        {
          signal: signal,
        },
      )
        .then((res) => {
          setResponse(res.data.data);
          setList(null);
          setArrayData(null);
          setAccount(null);
          setStatus(res.data.data.all);
          if (
            res?.data?.data?.message &&
            res?.data?.data?.message.trim() !== ""
          ) {
            toast.info(res.data.data.message);
          }
          res.data.data.accountability.map((x, i) => {
            let Obj = {
              name: x.flow_date,
              optionnew: x.option,
              value: x.accountability,
              option: x.option_month,
            };

            arryDatas.push(Obj);
          });
          setArrayData(arryDatas);

          setLoading(false);
        })
        .catch((err) => {
          if (err.name === "AbortError") {
            console.log("successfully aborted");
          }
        });
      return () => {
        // cancel the request before component unmounts

        controller.abort();
      };
    } else {
      if (
        defaultOption != "Custom" &&
        parameterone == null &&
        parametertwo == null &&
        accountability == true
      ) {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaa", listOfUsers);
        });
        get(
          `apis/accountability?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}`,

          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            setList(null);
            setArrayData(null);
            setAccount(null);
            setStatus(res.data.data.all);
            if (res.data.data.message && res.data.data.message.trim() !== "") {
              toast.info(res.data.data.message);
            }
            res.data.data.accountability.map((x, i) => {
              let Obj = {
                name: x.flow_date,
                optionnew: x.option,
                value: x.accountability,
                option: x.option_month,
              };

              arryDatas.push(Obj);
            });
            setArrayData(arryDatas);

            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          // cancel the request before component unmounts

          controller.abort();
        };
      }
    }
  }, [
    accountability,
    optionone,
    defaultOption,
    optiononenew,
    slvalue,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);
  useEffect(() => {
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined &&
      demand == true
    ) {
      if (optionone == "potable") {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaa", listOfUsers);
        });
        get(
          `apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            setList(response.code_list);
            setArrayData(null);
            setAccount(null);
            setStatus(res.data.data.all);
            res.data.data.code_list.map((x, index) => {
              console.log(x);
              var a = "#";

              let Obj = {
                name: x.code_name,
                colour: color[index],
              };
              accountNews.push(Obj);
              setAccounts(accountNews);
            });

            res.data.data.account_flow.map((x, index) => {
              var a = "#";

              let Obj = {
                name: x.account_name,
                sum: x.sum,
                colour: color[index],
              };
              accountNew.push(Obj);
              setAccount(accountNew);
            });
            console.log(account);
            res.data.data.total_flow.map((x, i) => {
              if (classcodepotabledemand == "ALL" && optionone == "potable") {
                let name = x[0]?.flow_date;
                let optionnew = x[0]?.option;
                let option = x[0]?.option_month;
                const meterData = Object.fromEntries(
                  x?.map(({ code_name, flow }) => [code_name, flow]),
                );

                const weeklyMeterData = {
                  name,
                  optionnew,
                  option,
                  ...meterData,
                };

                arryDatas.push(weeklyMeterData);
                console.log(weeklyMeterData);
              } else {
                let name = x[0]?.flow_date;
                let optionnew = x[0]?.option;
                let option = x[0]?.option_month;
                const meterData = Object.fromEntries(
                  x?.map(({ account_name, flow }) => [account_name, flow]),
                );

                const weeklyMeterData = {
                  name,
                  optionnew,
                  option,
                  ...meterData,
                };

                arryDatas.push(weeklyMeterData);
              }
            });

            setArrayData(arryDatas);
            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          // cancel the request before component unmounts

          controller.abort();
        };
      } else if (optionone == "total") {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaa", listOfUsers);
        });
        get(
          `apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            setList(response.code_list);
            setArrayData(null);
            setAccount(null);
            setStatus(res.data.data.all);
            res.data.data.code_list.map((x, index) => {
              console.log(x);
              var a = "#";
              let Obj = {
                name: x.code_name,
                colour: color[index],
              };
              accountNews.push(Obj);
              setAccounts(accountNews);
            });
            res.data.data.account_flow.map((x, index) => {
              var a = "#";
              let Obj = {
                name: x.account_name,
                sum: x.sum,
                colour: color[index],
              };
              accountNew.push(Obj);
              setAccount(accountNew);
            });
            console.log(account);
            res.data.data.total_flow.map((x, i) => {
              if (classcodetotaldemand == "ALL" && optionone == "total") {
                let name = x[0]?.flow_date;
                let optionnew = x[0]?.option;
                let option = x[0]?.option_month;
                const meterData = Object.fromEntries(
                  x?.map(({ code_name, flow }) => [code_name, flow]),
                );

                const weeklyMeterData = {
                  name,
                  optionnew,
                  option,
                  ...meterData,
                };

                arryDatas.push(weeklyMeterData);
                console.log(weeklyMeterData);
              } else if (
                isFB151 &&
                optionone == "total" &&
                classcodetotaldemand !== "ALL"
              ) {
                const item = x[0];
                let Obj = {
                  name: item?.flow_date,
                  optionnew: item?.option,
                  option: item?.option_month,
                  // [item.code]: item?.flow,
                  value: item?.flow,
                };
                arryDatas.push(Obj);
                console.log("DISTB", arryDatas);

                // setArrayData(arryDatas);
                // setLoading(false);
              } else {
                let name = x[0]?.flow_date;
                let optionnew = x[0]?.option;
                let option = x[0]?.option_month;
                const meterData = Object.fromEntries(
                  x?.map(({ account_name, flow }) => [account_name, flow]),
                );

                const weeklyMeterData = {
                  name,
                  optionnew,
                  option,
                  ...meterData,
                };

                arryDatas.push(weeklyMeterData);
              }
            });

            setArrayData(arryDatas);
            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          controller.abort();
        };
      } else {
        setLoading(true);
        get(
          `apis/download/allflowanalytics?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
        ).then((response) => {
          console.log(response);
          setListofUsers(response.data);
          console.log("aaaaaaaaa", listOfUsers);
        });
        get(
          `apis/total_flow_demand?start_date=${parameterone}&end_date=${parametertwo}&option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
          {
            signal: signal,
          },
        )
          .then((res) => {
            setResponse(res.data.data);
            setList(response.code_list);
            setArrayData(null);
            setAccount(null);
            setStatus(res.data.data.all);
            res.data.data.total_flow.map((x, i) => {
              let Obj = {
                name: x[0]?.flow_date,
                optionnew: x[0]?.option,
                value: x[0]?.flow,
                option: x[0]?.option_month,
              };

              arryDatas.push(Obj);
            });
            setArrayData(arryDatas);
            setLoading(false);
          })
          .catch((err) => {
            if (err.name === "AbortError") {
              console.log("successfully aborted");
            }
          });
        return () => {
          // cancel the request before component unmounts

          controller.abort();
        };
      }
    } else {
      if (
        defaultOption != "Custom" &&
        parameterone == null &&
        parametertwo == null &&
        demand == true
      ) {
        if (optionone == "potable") {
          setLoading(true);
          get(
            `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`,
          ).then((response) => {
            console.log(response);
            setListofUsers(response.data);
            console.log("aaaaaaaaa", listOfUsers);
          });
          get(
            `apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodepotabledemand}`,

            {
              signal: signal,
            },
          )
            .then((res) => {
              setResponse(res.data.data);
              setList(response.code_list);
              setArrayData(null);
              setAccount(null);
              setStatus(res.data.data.all);
              let count = 0;
              res.data.data.code_list.map((x, index) => {
                console.log(x);
                var a = "#";
                let Obj = {
                  name: x.code_name,
                  colour: color[index],
                };
                accountNews.push(Obj);
                setAccounts(accountNews);
              });
              res.data.data.account_flow.map((x, index) => {
                var a = "#";

                let Obj = {
                  name: x.account_name,
                  sum: x.sum,
                  // colour: "#" + Math.random().toString(16).slice(2, 8)
                  colour: color[index],
                };
                accountNew.push(Obj);
                setAccount(accountNew);
              });
              console.log("account is", account);
              console.log("accounts is", accounts);
              res.data.data.total_flow.map((x, i) => {
                if (classcodepotabledemand == "ALL" && optionone == "potable") {
                  let name = x[0]?.flow_date;
                  let optionnew = x[0]?.option;
                  let option = x[0]?.option_month;
                  const meterData = Object.fromEntries(
                    x?.map(({ code_name, flow }) => [code_name, flow]),
                  );

                  const weeklyMeterData = {
                    name,
                    optionnew,
                    option,
                    ...meterData,
                  };

                  arryDatas.push(weeklyMeterData);
                  // console.log(weeklyMeterData);
                } else {
                  let name = x[0]?.flow_date;
                  let optionnew = x[0]?.option;
                  let option = x[0]?.option_month;
                  const meterData = Object.fromEntries(
                    x?.map(({ account_name, flow }) => [
                      account_name.trim(),
                      flow,
                    ]),
                  );

                  const weeklyMeterData = {
                    name,
                    optionnew,
                    option,
                    ...meterData,
                  };

                  arryDatas.push(weeklyMeterData);
                  //  console.log(weeklyMeterData);
                }
              });
              setArrayData(arryDatas);
              setLoading(false);
              console.log("arrayData", arryDatas);
              console.log("arrayDatalatest", arrayData);
            })
            .catch((err) => {
              if (err.name === "AbortError") {
                console.log("successfully aborted");
              }
            });
          return () => {
            // cancel the request before component unmounts

            controller.abort();
          };
        } else if (optionone == "total") {
          setLoading(true);
          get(
            `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`,
          ).then((response) => {
            console.log(response);
            setListofUsers(response.data);
            console.log("aaaaaaaaa", listOfUsers);
          });
          get(
            `apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=${classcodetotaldemand}`,

            {
              signal: signal,
            },
          )
            .then((res) => {
              //   console.log(res.data.data.total_flow);

              setResponse(res.data.data);
              setList(response.code_list);
              setArrayData(null);
              setAccount(null);
              // setTimeout(() => {
              setStatus(res.data.data.all);
              // }, 2000);
              res.data.data.code_list.map((x, index) => {
                console.log(x);
                var a = "#";

                let Obj = {
                  name: x.code_name,
                  // sum: x.sum,
                  // colour: "#" + Math.random().toString(16).slice(2, 8)
                  colour: color[index],
                };
                accountNews.push(Obj);
                setAccounts(accountNews);
              });
              res.data.data.account_flow.map((x, index) => {
                var a = "#";

                let Obj = {
                  name: x.account_name,
                  sum: x.sum,
                  // colour: "#" + Math.random().toString(16).slice(2, 8)
                  colour: color[index],
                };
                accountNew.push(Obj);
                setAccount(accountNew);
              });
              console.log("account is", account);
              console.log("accounts is", accounts);
              res.data.data.total_flow.map((x, i) => {
                if (classcodetotaldemand == "ALL" && optionone == "total") {
                  let name = x[0]?.flow_date;
                  let optionnew = x[0]?.option;
                  let option = x[0]?.option_month;
                  const meterData = Object.fromEntries(
                    x?.map(({ code_name, flow }) => [code_name, flow]),
                  );

                  const weeklyMeterData = {
                    name,
                    optionnew,
                    option,
                    ...meterData,
                  };

                  arryDatas.push(weeklyMeterData);
                  console.log(weeklyMeterData);
                } else if (
                  isFB151 &&
                  optionone == "total" &&
                  classcodetotaldemand !== "ALL"
                ) {
                  const item = x[0];
                  let Obj = {
                    name: item?.flow_date,
                    optionnew: item?.option,
                    option: item?.option_month,
                    // [item.code]: item?.flow,
                    value: item?.flow,
                  };
                  arryDatas.push(Obj);
                  console.log("DISTB", arryDatas);

                  // setArrayData(arryDatas);
                  // setLoading(false);
                } else {
                  let name = x[0]?.flow_date;
                  let optionnew = x[0]?.option;
                  let option = x[0]?.option_month;
                  const meterData = Object.fromEntries(
                    x?.map(({ account_name, flow }) => [account_name, flow]),
                  );

                  const weeklyMeterData = {
                    name,
                    optionnew,
                    option,
                    ...meterData,
                  };

                  arryDatas.push(weeklyMeterData);
                }
              });
              setArrayData(arryDatas);
              setLoading(false);
              console.log(arrayData);
            })
            .catch((err) => {
              if (err.name === "AbortError") {
                console.log("successfully aborted");
              }
            });
          return () => {
            // cancel the request before component unmounts

            controller.abort();
          };
        } else {
          setLoading(true);
          get(
            `apis/download/allflowanalytics?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,
          ).then((response) => {
            console.log(response);
            setListofUsers(response.data);
            console.log("aaaaaaaaa", listOfUsers);
          });
          get(
            `apis/total_flow_demand?option=${defaultOption}&interval=${optiononenew}&number=${slvalue}&system=${optionone}&class_code=ALL`,

            {
              signal: signal,
            },
          )
            .then((res) => {
              setResponse(res.data.data);
              setList(response.code_list);
              setArrayData(null);
              setAccount(null);

              setStatus(res.data.data.all);

              res.data.data.total_flow.map((x, i) => {
                let Obj = {
                  name: x[0]?.flow_date,
                  optionnew: x[0]?.option,
                  value: x[0]?.flow,

                  option: x[0]?.option_month,
                };

                arryDatas.push(Obj);
              });
              setArrayData(arryDatas);
              setLoading(false);
            })
            .catch((err) => {
              if (err.name === "AbortError") {
                console.log("successfully aborted");
              }
            });
          return () => {
            controller.abort();
          };
        }
      }
    }
  }, [
    demand,
    optionone,
    defaultOption,
    optiononenew,
    slvalue,
    classcodepotabledemand,
    classcodetotaldemand,
    parameterone,
    parametertwo,
    selectedDistrict,
  ]);
  const sliderChange = (event) => {
    setSlvalue(event.target.value);
  };

  const onMouseClick = (event) => {
    setSlvalue(1);
    setParameterone(null);
    setParametertwo(null);

    setDefaultOption(event.target.value);
    if (event.target.value == "Past Day") {
      setOptiononenew("Hours");
    } else if (
      event.target.value == "Past Year" ||
      event.target.value == "Past Month" ||
      event.target.value == "Past 3 Months" ||
      event.target.value == "Custom"
    ) {
      setOptiononenew("Days");
    } else if (event.target.value == "Past Week") {
      setOptiononenew("Days");
    }
  };

  const handleFlowPageclick = () => {
    console.log("flow Analytics");
  };

  const handlePredictivePageclick = () => {
    console.log("Predictive Analytics");

    navigate("/predictiveanalysis");
  };
  const handleAnomalypageclick = () => {
    console.log("Predictive Analytics");
    navigate("/Anomaly");
  };

  const radioChanges = (event) => {
    setOptionone(event.target.value);

    setAccountability(true);
    setDemand(false);
    setProduced(false);
    setSupply(false);
    setName("Accountability");
  };

  const radioChange = (event) => {
    event.stopPropagation();
    setSlvalue(1);
    setOptiononenew(event.target.id);
  };
  const radioChangedroptotaldemand = (event) => {
    setClasscodetotaldemand(event.target.id);
  };
  const radioChangedroptotalsupply = (event) => {
    setClasscodetotalsupply(event.target.id);
  };
  const radioChangedroppotabledemand = (event) => {
    setClasscodepotabledemand(event.target.id);
  };
  const radioChangedroppotablesupply = (event) => {
    console.log(event.target.id);
    setClasscodepotablesupply(event.target.id);
  };

  const onRedirection = (event) => {
    navigate(-1);
  };
  const onselectClicks = () => {
    setName("Accountability");
    setAccountability(true);
    setProduced(false);
    setDemand(false);
    setSupply(false);
    setPrediction(false);
  };
  const onselectClicksupply = () => {
    setSupply(true);
    setAccountability(false);
    setProduced(false);
    setDemand(false);
    setName("Supply");
    setPrediction(false);
  };
  const onselectClickdemand = () => {
    setDemand(true);
    setSupply(false);
    setAccountability(false);
    setProduced(false);
    setName("Demand");
    setPrediction(false);
  };
  const onselectClickprediction = () => {
    setPrediction(true);
    setSupply(false);
    setAccountability(false);
    setProduced(false);
    setDemand(false);
    setName("Prediction");
  };
  const onselectClickproduced = () => {
    setDemand(false);
    setSupply(false);
    setAccountability(false);
    setProduced(true);
    setPrediction(false);
    setName("Produced");
  };
  const onselectClick = () => {
    navigate("/outlierovertime");
  };

  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onRedirection}
            />
            {/* <h3 className="mb-0">Flow Analytics</h3> */}
            <div className="d-flex align-items-center">
              <div
                className="new-box-padding  text-blue  align-self-center c-pointer "
                onClick={handleFlowPageclick}
                style={{
                  borderBottom: "2px solid #1998f0",
                  borderRadius: "0",
                }}
              >
                Flow Analytics
                {datastatusaccontability === true ? (
                  <span className="ms-2" style={{ color: "red" }}>
                    !
                  </span>
                ) : (
                  ""
                )}
              </div>
              {/* {!isFB151 && (
                <> */}
              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer"
                onClick={handlePredictivePageclick}
                style={{
                  borderBottom: "2px solid #ccc",
                }}
              >
                Predictive Analytics
              </div>

              {/* </>
              )} */}
              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding   align-self-center c-pointer"
                onClick={handleAnomalypageclick}
                style={{
                  borderBottom: "2px solid #ccc",
                }}
              >
                Anomaly Detection
                {datastatusanomaly === true ? (
                  <span className="ms-2" style={{ color: "red" }}>
                    !
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="bottom-layout">
          <div id="domEl" ref={domEl}>
            <div class="container-fluid pb-4 px-0 flex-column pt-4">
              <div class="row row-cols-3 g-3">
                <div className="col-12 mt-1">
                  <Card bordered={false} className="checkStatusHealth">
                    <div className="fs-20 ">
                      <div className="d-flex gap-3 justify-content-between align-items-end  flex-wrap">
                        <div className="d-flex flex-wrap">
                          {prediction === true ? (
                            ""
                          ) : (
                            <>
                              <div className="totalflow-width mt-0 me-2">
                                <div className="w-100 text-blue total-flow-font-size">
                                  Date Range
                                </div>
                                <div
                                  id="1st"
                                  className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
                                              justify-content-center water-date"
                                >
                                  <div className="d-flex w-100">
                                    <div className="fs-26 fw-bold w-100 justify-content-between d-flex  water">
                                      <select
                                        name="All meters"
                                        id="selector"
                                        className="box"
                                        onChange={onMouseClick}
                                      >
                                        <option value="Past Year">
                                          Past 365 Days
                                        </option>
                                        <option value="Past 3 Months">
                                          Past 90 Days
                                        </option>
                                        <option value="Past Month" selected>
                                          Past 30 Days
                                        </option>
                                        <option value="Past Week">
                                          Past Week
                                        </option>
                                        <option value="Past Day">
                                          Past Day
                                        </option>
                                        <option value="Custom">Custom</option>
                                      </select>
                                    </div>
                                    <Space
                                      direction="horizontal"
                                      size={1}
                                      className="custom-date"
                                    >
                                      {defaultOption === "Custom" ? (
                                        <RangePicker
                                          onChange={onchange}
                                          disabledDate={disabledDate}
                                          separator={<SwapOutlined />}
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </Space>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          {prediction === true ? (
                            ""
                          ) : (
                            <>
                              <div className="totalflow-width mt-0 me-2">
                                <div className="w-100 text-blue total-flow-font-size">
                                  Interval
                                </div>
                                <div className="dropdown intervaldropdown">
                                  <button
                                    className="btn  w-100 p-1 d-flex justify-content-between align-items-center"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    {optiononenew === "Months"
                                      ? optiononenew
                                      : slvalue + " " + optiononenew}
                                    <span
                                      className="d-block"
                                      style={{ lineHeight: "0" }}
                                    >
                                      {" "}
                                      <CaretDownOutlined />{" "}
                                    </span>
                                  </button>
                                  <ul
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton1"
                                  >
                                    <li className="interdrop">
                                      {" "}
                                      {defaultOption == "Past Week" ? (
                                        <>
                                          <div class="form-check d-flex align-items-center">
                                            <Input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadioDefault"
                                              id="Days"
                                              onClick={radioChange}
                                              defaultChecked="true"
                                            />
                                            <label
                                              className="form-check-label"
                                              for="Days"
                                              onClick={radioChange}
                                            >
                                              Days
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {defaultOption == "Past Day" ? (
                                        <>
                                          <div class="form-check d-flex align-items-center">
                                            <Input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadioDefault"
                                              id="Hours"
                                              onClick={radioChange}
                                              defaultChecked="true"
                                            />
                                            <label
                                              className="form-check-label"
                                              for="Hours"
                                              onClick={radioChange}
                                            >
                                              Hours
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {defaultOption == "Past 3 Months" ||
                                      defaultOption == "Past Month" ? (
                                        <>
                                          <div class="form-check d-flex align-items-center">
                                            <Input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadioDefault"
                                              id="Days"
                                              onClick={radioChange}
                                              //   defaultChecked="true"
                                            />
                                            <label
                                              className="form-check-label"
                                              for="Days"
                                              onClick={radioChange}
                                            >
                                              Days
                                            </label>
                                          </div>
                                          <div class="form-check d-flex align-items-center">
                                            <Input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadioDefault"
                                              id="Weeks"
                                              onClick={radioChange}
                                              checked={optiononenew === "Weeks"}
                                              defaultChecked="true"
                                            />
                                            <label
                                              className="form-check-label"
                                              for="Weeks"
                                              onClick={radioChange}
                                            >
                                              Weeks
                                            </label>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {defaultOption === "Past Year" ||
                                      defaultOption == "Custom" ? (
                                        <>
                                          <div class="form-check d-flex align-items-center">
                                            <Input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadioDefault"
                                              id="Days"
                                              onClick={radioChange}
                                              //   defaultChecked="true"
                                            />
                                            <label
                                              className="form-check-label"
                                              for="Days"
                                              onClick={radioChange}
                                            >
                                              Days
                                            </label>
                                          </div>
                                          <div class="form-check d-flex align-items-center">
                                            <Input
                                              className="form-check-input"
                                              type="radio"
                                              name="flexRadioDefault"
                                              id="Weeks"
                                              onClick={radioChange}
                                              defaultChecked="true"
                                              checked={optiononenew === "Weeks"}
                                            />
                                            <label
                                              className="form-check-label"
                                              for="Weeks"
                                              onClick={radioChange}
                                            >
                                              Weeks
                                            </label>
                                          </div>
                                          {defaultOption === "Past Year" ||
                                          (defaultOption === "Custom" &&
                                            (new Date(parametertwo) -
                                              new Date(parameterone)) /
                                              (1000 * 60 * 60 * 24) >
                                              179) ? (
                                            <div class="form-check d-flex align-items-center">
                                              <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="Months"
                                                onClick={radioChange}
                                                defaultChecked="true"
                                                checked={
                                                  optiononenew === "Months"
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                for="Months"
                                                onClick={radioChange}
                                              >
                                                Months
                                              </label>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </li>
                                    {optiononenew !== "Months" ? (
                                      <li
                                        className="interdrop"
                                        style={{ borderTop: "1px solid #ccc" }}
                                      >
                                        <div className="d-flex w-100 align-items-center mt-2 justify-content-between">
                                          <label className="me-4">Range</label>
                                          <div className="fs-26 fw-bold d-flex w-50 water">
                                            {optiononenew == "Weeks" ? (
                                              <select
                                                name="All meters"
                                                id="selector"
                                                className="box"
                                                onChange={sliderChange}
                                                style={{
                                                  border: "1px solid #ccc",
                                                }}
                                              >
                                                <option value="1" selected>
                                                  1
                                                </option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                              </select>
                                            ) : (
                                              <select
                                                name="All meters"
                                                id="selector"
                                                className="box"
                                                onChange={sliderChange}
                                                style={{
                                                  border: "1px solid #ccc",
                                                }}
                                              >
                                                <option value="1" selected>
                                                  1
                                                </option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                              </select>
                                            )}
                                          </div>
                                        </div>
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                          {!isFB151 ? (
                            <>
                              {" "}
                              <div className="totalflow-width mt-0 me-2">
                                <div className="w-100 text-blue total-flow-font-size">
                                  System
                                </div>

                                <div
                                  className="w-100 d-flex p-1 selectCalender ms-auto mt-0 water-space  align-items-center
                                              justify-content-center"
                                >
                                  <div className="d-flex w-100">
                                    <div className="fs-26 fw-bold d-flex w-100 water">
                                      <select
                                        name="All"
                                        id="selector"
                                        className="box"
                                        onChange={radioChanges}
                                      >
                                        <option value="non_potable">
                                          Non-Potable{" "}
                                        </option>
                                        <option value="potable">Potable</option>
                                        <option value="total" selected>
                                          Plant{" "}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="d-flex align-items-center">
                          {optionone == "total" ? (
                            <div className="d-flex flex-wrap">
                              {accountability === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicks}
                                >
                                  Accountability
                                  <tooltip title="(Demand/Supply)*100">
                                    <InfoCircleOutlined
                                      className="ms-1 text-blue"
                                      style={{ fontSize: "14px" }}
                                    />
                                  </tooltip>
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicks}
                                >
                                  Accountability
                                  <tooltip title="(Demand/Supply)*100">
                                    <InfoCircleOutlined
                                      className="ms-1 text-blue"
                                      style={{ fontSize: "14px" }}
                                    />
                                  </tooltip>
                                </div>
                              )}
                              {/* {Produced === true ? <div className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                                                onClick={onselectClickproduced}
                                                            >
                                                               {isFB151 ? "Supply" : "Intake"}
                                                            </div> : <div className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                                                onClick={onselectClickproduced}
                                                            >
                                                                {isFB151 ? "Supply" : "Intake"}
                                                            </div>} */}
                              {!isFB151 &&
                                (Produced === true ? (
                                  <div
                                    className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                    onClick={onselectClickproduced}
                                  >
                                    Intake
                                  </div>
                                ) : (
                                  <div
                                    className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                    onClick={onselectClickproduced}
                                  >
                                    Intake
                                  </div>
                                ))}
                              {/* { !isFB151 && (<> */}
                              {supply === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicksupply}
                                >
                                  {" "}
                                  Supply
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicksupply}
                                >
                                  Supply
                                </div>
                              )}
                              {/* </>

                                                         )} */}

                              {demand === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClickdemand}
                                >
                                  {" "}
                                  Demand
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClickdemand}
                                >
                                  {" "}
                                  Demand
                                </div>
                              )}
                            </div>
                          ) : optionone == "potable" ? (
                            <div className="d-flex flex-wrap">
                              {accountability === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicks}
                                >
                                  Accountability
                                  <tooltip title="(Demand/Supply)*100">
                                    <InfoCircleOutlined
                                      className="ms-1 text-blue"
                                      style={{ fontSize: "14px" }}
                                    />
                                  </tooltip>
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicks}
                                >
                                  Accountability
                                  <tooltip title="(Demand/Supply)*100">
                                    <InfoCircleOutlined
                                      className="ms-1 text-blue"
                                      style={{ fontSize: "14px" }}
                                    />
                                  </tooltip>
                                </div>
                              )}
                              {supply === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicksupply}
                                >
                                  {" "}
                                  Supply
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicksupply}
                                >
                                  Supply
                                </div>
                              )}

                              {demand === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer  me-2"
                                  onClick={onselectClickdemand}
                                >
                                  {" "}
                                  Demand
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer  me-2"
                                  onClick={onselectClickdemand}
                                >
                                  {" "}
                                  Demand
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="d-flex flex-wrap">
                              {accountability === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicks}
                                >
                                  Accountability
                                  <tooltip title="(Demand/Supply)*100">
                                    <InfoCircleOutlined
                                      className="ms-1 text-blue"
                                      style={{ fontSize: "14px" }}
                                    />
                                  </tooltip>
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicks}
                                >
                                  Accountability
                                  <tooltip title="(Demand/Supply)*100">
                                    <InfoCircleOutlined
                                      className="ms-1 text-blue"
                                      style={{ fontSize: "14px" }}
                                    />
                                  </tooltip>
                                </div>
                              )}
                              {supply === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicksupply}
                                >
                                  {" "}
                                  Supply
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1 mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClicksupply}
                                >
                                  Supply
                                </div>
                              )}

                              {demand === true ? (
                                <div
                                  className="px-3 py-1 mt-4 text-blue bg-white border border-info rounded align-self-center c-pointer me-2"
                                  onClick={onselectClickdemand}
                                >
                                  {" "}
                                  Demand
                                </div>
                              ) : (
                                <div
                                  className="px-3 py-1  mt-4 bg-white border rounded align-self-center c-pointer me-2"
                                  onClick={onselectClickdemand}
                                >
                                  {" "}
                                  Demand
                                </div>
                              )}
                            </div>
                          )}
                          {/*  */}
                          <div className="ml-auto downloadflow float-right">
                            <Dropdown
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space>
                                  <img
                                    src={download}
                                    alt="download"
                                    style={{ width: "25px" }}
                                    title="download"
                                  />
                                  {/* Download
                                        <CaretDownOutlined /> */}
                                </Space>
                              </a>
                            </Dropdown>
                          </div>

                          {/*  */}
                        </div>
                      </div>
                    </div>

                    {prediction === true ? (
                      <div className="row mx-0 mt-5">
                        <div className="col-12 col-lg-12">
                          <div
                            style={{ fontSize: "18px" }}
                            // className="totalflow-graph"
                          >
                            <LineChart
                              width={1500}
                              height={500}
                              data={datapredictions}
                              // margin={{ top: 10, right: 20, bottom: 5, left: 0 }}
                              margin={{
                                top: 10,
                                right: 20,
                                bottom: 60,
                                left: 0,
                              }}
                            >
                              <Line
                                type={type}
                                dataKey="actualvalue"
                                stroke="#8884d8"
                                dot={false}
                                strokeWidth={3}
                              />
                              <Line
                                type={type}
                                dataKey="predictedvalue"
                                stroke="#82ca9d"
                                dot={false}
                                strokeWidth={3}
                              />
                              <Line
                                type={type}
                                dataKey="Flow"
                                stroke="url(#gradient)"
                                dot={false}
                                strokeWidth={3}
                              />
                              <XAxis
                                dataKey="week"
                                angle={-40}
                                tick={{ dy: 20 }}
                                style={{ fontSize: "12px" }}
                              />
                              <YAxis>
                                <Label
                                  value="Kilo Gallons"
                                  position="insideLeft"
                                  angle={-90}
                                  style={{
                                    textAnchor: "middle",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    padding: "0 10px",
                                  }}
                                />
                              </YAxis>
                              {/* <Tooltip /> */}
                              <Tooltip
                                formatter={(value, name) => [
                                  Number(value)?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }),
                                  name,
                                ]}
                              />

                              <Legend
                                content={(props) => {
                                  const { payload } = props;
                                  return (
                                    <ul
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        listStyleType: "none",
                                        padding: 0,
                                      }}
                                    >
                                      {payload.map((entry, index) => (
                                        <li
                                          key={`item-${index}`}
                                          style={{ color: entry.color }}
                                        >
                                          {entry.value === "Flow"
                                            ? "Flow"
                                            : entry.value}
                                        </li>
                                      ))}
                                    </ul>
                                  );
                                }}
                              />
                            </LineChart>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {loading === true ? (
                          <div className="example">
                            <Spin size="large" />
                          </div>
                        ) : (
                          <>
                            <div className="row mx-0 mt-5">
                              <div className="col-12 col-lg-9">
                                <div
                                  style={{
                                    maxWidth: "100%",
                                    margin: "0 auto",
                                    height: "700px",
                                  }}
                                  className="totalflow-graph"
                                >
                                  {accountability === true ? (
                                    <>
                                      <ResponsiveContainer
                                        width="100%"
                                        height="100%"
                                      >
                                        <LineChart
                                          width={500}
                                          height={400}
                                          data={arrayData}
                                          margin={{
                                            top: 10,
                                            right: 30,
                                            left: 10,
                                            bottom: 0,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />

                                          <ReferenceLine
                                            y={response.average}
                                            stroke="blue"
                                            strokeDasharray="5 5"
                                            label={{
                                              value: `Avg (${
                                                response.average
                                                  ? response.average
                                                  : "0"
                                              })`,
                                              position: "right",
                                              fill: "blue",
                                              fontSize: 14,
                                            }}
                                          />

                                          <ReferenceArea
                                            y1={60}
                                            y2={85}
                                            stroke="orange"
                                            fill="#ffbf00"
                                          />

                                          <ReferenceArea
                                            y1={85}
                                            y2={95}
                                            stroke="yellow"
                                            fill="#FFFF00"
                                          />

                                          <ReferenceArea
                                            y1={95}
                                            y2={100}
                                            stroke="#66ff66"
                                            fill="#66ff66"
                                          />
                                          <XAxis
                                            xAxisId="0"
                                            dataKey="name"
                                            tick={false}
                                            angle={-45}
                                            textAnchor="end"
                                          />
                                          {defaultOption === "Past Year" ||
                                          value > 12 ||
                                          optiononenew === "Months" ? (
                                            ""
                                          ) : (
                                            <XAxis
                                              dataKey="optionnew"
                                              allowDuplicatedCategory={false}
                                              xAxisId="1"
                                            />
                                          )}
                                          <XAxis
                                            dataKey="option"
                                            allowDuplicatedCategory={false}
                                            xAxisId="2"
                                          />

                                          <YAxis
                                            type="number"
                                            domain={[60, 110]}
                                            tickCount={11}
                                            tick={{
                                              fill: "#666",
                                              fontSize: "14px",
                                            }}
                                            ticks={[
                                              60, 65, 70, 75, 80, 85, 90, 95,
                                              100, 105, 110,
                                            ]}
                                          >
                                            <Label
                                              value="Plant Demand/Plant Supply %"
                                              position="insideLeft"
                                              angle={-90}
                                              style={{
                                                textAnchor: "middle",
                                                fontSize: "18px",
                                                fontWeight: "600",
                                              }}
                                            />
                                          </YAxis>
                                          {/* <Tooltip
                                                                                    formatter={(value, name, props) => [props.payload.value, name]}
                                                                                /> */}
                                          <Tooltip
                                            formatter={(value, name, props) => [
                                              props?.payload?.value?.toLocaleString(), // adds comma separators
                                              name,
                                            ]}
                                          />
                                          <Line
                                            type="monotone"
                                            dataKey={(data) =>
                                              Math.min(
                                                Math.max(data.value, 60),
                                                110,
                                              )
                                            }
                                            stroke="#ff99c2"
                                            strokeWidth={2}
                                            dot={false}
                                          />
                                        </LineChart>
                                      </ResponsiveContainer>
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  {accountability === false &&
                                  Produced === false &&
                                  ((optionone == "potable" && demand == true) ||
                                    optionone == "total") ? (
                                    <>
                                      <ResponsiveContainer
                                        width="100%"
                                        height="100%"
                                      >
                                        <AreaChart
                                          width={500}
                                          height={400}
                                          data={arrayData}
                                          margin={{
                                            top: 10,
                                            right: 30,
                                            left: 10,
                                            bottom: 0,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />

                                          <YAxis type="number"></YAxis>
                                          <Tooltip
                                            content={renderTooltipContent}
                                          />

                                          <XAxis
                                            xAxisId="0"
                                            dataKey="name"
                                            tick={false}
                                            angle={-45}
                                            textAnchor="end"
                                          />
                                          {defaultOption === "Past Year" ||
                                          value > 10 ||
                                          optiononenew === "Months" ? (
                                            ""
                                          ) : (
                                            <XAxis
                                              dataKey="optionnew"
                                              allowDuplicatedCategory={false}
                                              xAxisId="1"
                                            />
                                          )}
                                          <XAxis
                                            dataKey="option"
                                            allowDuplicatedCategory={false}
                                            xAxisId="2"
                                          />

                                          {demand === true &&
                                          classcodetotaldemand == "ALL" &&
                                          optionone == "total" ? (
                                            accounts?.map((item, index) => (
                                              <Area
                                                type="monotone"
                                                dataKey={item.name}
                                                stackId="1"
                                                stroke={item.colour}
                                                fill={item.colour}
                                              />
                                            ))
                                          ) : demand === true &&
                                            isFB151 &&
                                            classcodetotaldemand !== "ALL" &&
                                            optionone == "total" ? (
                                            <Area
                                              type="monotone"
                                              dataKey="value"
                                              stackId="1"
                                              stroke="#58D68D"
                                              fill="#58D68D"
                                            />
                                          ) : demand === true &&
                                            classcodepotabledemand == "ALL" &&
                                            optionone == "potable" ? (
                                            accounts?.map((item, index) => (
                                              <Area
                                                type="monotone"
                                                dataKey={item.name}
                                                stackId="1"
                                                stroke={item.colour}
                                                fill={item.colour}
                                              />
                                            ))
                                          ) : demand === true ||
                                            (isFB151 && supply === true) ? (
                                            account
                                              ?.filter((item) =>
                                                arrayData?.some((entry) =>
                                                  Object.keys(entry).includes(
                                                    item?.name?.trim(),
                                                  ),
                                                ),
                                              )
                                              .map((item, index) => {
                                                console.log(
                                                  "Plotted account:",
                                                  item?.name,
                                                );
                                                return (
                                                  <Area
                                                    key={index}
                                                    type="monotone"
                                                    dataKey={item?.name?.trim()}
                                                    stackId="1"
                                                    stroke={
                                                      item?.colour?.trim?.() ||
                                                      item?.colour
                                                    }
                                                    fill={
                                                      item?.colour?.trim?.() ||
                                                      item?.colour
                                                    }
                                                  />
                                                );
                                              })
                                          ) : (
                                            <Area
                                              type="monotone"
                                              dataKey="value"
                                              stackId="1"
                                              stroke="#8884d8"
                                              fill="#8884d8"
                                            />
                                          )}
                                        </AreaChart>
                                        <div className="labelYAxis7">
                                          Gallons{" "}
                                        </div>
                                      </ResponsiveContainer>
                                    </>
                                  ) : accountability === false ? (
                                    <>
                                      <ResponsiveContainer
                                        width="100%"
                                        height="100%"
                                      >
                                        <AreaChart
                                          width={500}
                                          height={400}
                                          data={arrayData}
                                          margin={{
                                            top: 10,
                                            right: 30,
                                            left: 10,
                                            bottom: 0,
                                          }}
                                        >
                                          <CartesianGrid strokeDasharray="3 3" />

                                          <XAxis
                                            xAxisId="0"
                                            dataKey="name"
                                            tick={false}
                                            angle={-45}
                                            textAnchor="end"
                                          />
                                          {defaultOption === "Past Year" ||
                                          value > 12 ||
                                          optiononenew === "Months" ? (
                                            ""
                                          ) : (
                                            <XAxis
                                              dataKey="optionnew"
                                              allowDuplicatedCategory={false}
                                              xAxisId="1"
                                            />
                                          )}
                                          <XAxis
                                            dataKey="option"
                                            allowDuplicatedCategory={false}
                                            xAxisId="2"
                                          />

                                          {accountability === true ? (
                                            <YAxis
                                              type="number"
                                              domain={[60, 110]}
                                              tickCount={11}
                                              tick={{
                                                fill: "#666",
                                                fontSize: "14px",
                                              }}
                                              ticks={[
                                                60, 65, 70, 75, 80, 85, 90, 95,
                                                100, 105, 110,
                                              ]}
                                            >
                                              <Label
                                                value="Plant Demand/Plant Produced %"
                                                position="insideLeft"
                                                angle={-90}
                                                style={{
                                                  textAnchor: "middle",
                                                  fontSize: "18px",
                                                  fontWeight: "600",
                                                  padding: "0 10px",
                                                }}
                                              />
                                            </YAxis>
                                          ) : (
                                            <YAxis type="number">
                                              <div className="labelYAxis7">
                                                Gallons{" "}
                                              </div>
                                            </YAxis>
                                          )}

                                          {/* <Tooltip /> */}
                                          <Tooltip
                                            formatter={(value, name) => [
                                              Number(value)?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                },
                                              ),
                                              name,
                                            ]}
                                          />

                                          {demand === true &&
                                          optionone == "non_potable" ? (
                                            <Area
                                              type="monotone"
                                              dataKey="value"
                                              stackId="1"
                                              stroke={color[0]}
                                              fill={color[0]}
                                            />
                                          ) : supply === true &&
                                            optionone == "potable" ? (
                                            <Area
                                              type="monotone"
                                              dataKey="value"
                                              stackId="1"
                                              stroke={color[0]}
                                              fill={color[0]}
                                            />
                                          ) : supply === true &&
                                            optionone == "total" ? (
                                            <Area
                                              type="monotone"
                                              dataKey="value"
                                              stackId="1"
                                              stroke={color[0]}
                                              fill={color[0]}
                                            />
                                          ) : (
                                            arrayData?.length > 0 &&
                                            Object.keys(arrayData[0])
                                              .filter(
                                                (key) =>
                                                  ![
                                                    "name",
                                                    "optionnew",
                                                    "option",
                                                  ].includes(key),
                                              )
                                              .map((key, index) => (
                                                <Area
                                                  key={key}
                                                  type="monotone"
                                                  dataKey={key}
                                                  stackId="1"
                                                  stroke={
                                                    color[
                                                      index % color.length
                                                    ] || "#8884d8"
                                                  }
                                                  fill={
                                                    color[
                                                      index % color.length
                                                    ] || "#8884d8"
                                                  }
                                                />
                                              ))
                                          )}
                                        </AreaChart>
                                        <div className="labelYAxis7">
                                          Gallons{" "}
                                        </div>
                                      </ResponsiveContainer>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              {accountability === true ? (
                                <div className="col-12 col-lg-3 trenddemand px-3">
                                  <div className="d-flex justify-content-between bg-flow mb-2 px-2">
                                    <span className=" fs-15">Average</span>
                                    <span className=" fs-15">
                                      {response.average}%
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between bg-flow mb-2 px-2">
                                    <span className=" fs-15">Maximum</span>
                                    <span className=" fs-15">
                                      {response.maximum}%
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between bg-flow mb-2 px-2">
                                    <span className=" fs-15">Minimum</span>
                                    <span className=" fs-15">
                                      {response.minimum}%
                                    </span>
                                  </div>
                                </div>
                              ) : supply === true &&
                                (optionone == "total" ||
                                  optionone === "potable") ? (
                                <div className="col-12 col-lg-3 trenddemand px-3">
                                  <div className="col">
                                    <ul className="mb-3 p-0">
                                      <li className="interdrop">
                                        {optionone === "potable" &&
                                          !isFB151 && (
                                            <>
                                              <div className="form-check d-flex align-items-center mt-15 px-6">
                                                <Input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="flexRadioDefaultdroppotables"
                                                  id="ALL"
                                                  onChange={
                                                    radioChangedroppotablesupply
                                                  }
                                                  defaultChecked="true"
                                                  checked={
                                                    classcodepotablesupply ==
                                                    "ALL"
                                                  }
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  for="ALL"
                                                >
                                                  All
                                                </label>
                                              </div>

                                              <div class="form-check d-flex align-items-center">
                                                <Input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="flexRadioDefaultdroppotables"
                                                  id="DDOP1"
                                                  onChange={
                                                    radioChangedroppotablesupply
                                                  }
                                                  checked={
                                                    classcodepotablesupply ===
                                                    "DDOP1"
                                                  }
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  for="DDOP1"
                                                >
                                                  Distribution
                                                </label>
                                              </div>

                                              <div className="form-check d-flex align-items-center">
                                                <Input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="flexRadioDefaultdroppotables"
                                                  id="DXOP1"
                                                  onChange={
                                                    radioChangedroppotablesupply
                                                  }
                                                  checked={
                                                    classcodepotablesupply ===
                                                    "DXOP1"
                                                  }
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  for="DXOP1"
                                                >
                                                  Interconnect (In)
                                                </label>
                                              </div>
                                            </>
                                          )}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <h5 className="mb-0">Account</h5>
                                    <h5 className="mb-0">Gallons</h5>
                                  </div>
                                  <div className="d-flex justify-content-between mt-2">
                                    <span className="text-blue fs-15">
                                      Total
                                    </span>
                                    <span className="text-blue fs-15">
                                      {response.total
                                        ? response.total
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )
                                        : 0}
                                    </span>
                                  </div>
                                  {response.account_flow?.map(
                                    (person, index) => (
                                      // <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
                                      <div className="d-flex justify-content-between align-items-center mt-3 px-2 bg-flow">
                                       <div className="d-flex align-items-center gap-2">
                                        <span
                                          className="account-color-box"
                                          style={{
                                            backgroundColor: color[index],
                                          }}
                                        />
                                        <p className="fs-15 fw-semibold mb-0 text-left">
                                          {person.account_name}
                                        </p>
                                        </div>
                                        <p className="fs-15 fw-semibold mb-0">
                                          {person.sum
                                            ? Number.parseFloat(person.sum)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )
                                            : 0}
                                        </p>
                                      </div>
                                    ),
                                  )}
                                </div>
                              ) : demand === true &&
                                (optionone == "potable" ||
                                  optionone == "total") ? (
                                <div className="col-12 col-lg-3 trenddemand px-3">
                                  <div className="col">
                                    <h5 className=" categories-div">
                                      Categories
                                    </h5>
                                    <ul className="mb-3 p-0">
                                      <li className="interdrop">
                                        {optionone == "potable" ? (
                                          <>
                                            <div className="form-check d-flex align-items-center mt-15 px-6">
                                              <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefaultdroppotables"
                                                id="ALL"
                                                onChange={
                                                  radioChangedroppotabledemand
                                                }
                                                defaultChecked="true"
                                                checked={
                                                  classcodepotabledemand ==
                                                  "ALL"
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                for="ALL"
                                              >
                                                All
                                              </label>
                                            </div>

                                            <div class="form-check d-flex align-items-center">
                                              <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefaultdroppotables"
                                                id="DICP1"
                                                onChange={
                                                  radioChangedroppotabledemand
                                                }
                                                checked={
                                                  classcodepotabledemand ===
                                                  "DICP1"
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                for="DICP1"
                                              >
                                                Potable Irrigation
                                              </label>
                                            </div>

                                            <div className="form-check d-flex align-items-center">
                                              <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefaultdroppotables"
                                                id="DKRP1"
                                                onChange={
                                                  radioChangedroppotabledemand
                                                }
                                                checked={
                                                  classcodepotabledemand ===
                                                  "DKRP1"
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                for="DKRP1"
                                              >
                                                Potable Domestic
                                              </label>
                                            </div>
                                            <div className="form-check d-flex align-items-center">
                                              <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefaultdroppotables"
                                                id="DFCP1"
                                                onChange={
                                                  radioChangedroppotabledemand
                                                }
                                                checked={
                                                  classcodepotabledemand ===
                                                  "DFCP1"
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                for="DFCP1"
                                              >
                                                Potable Fire
                                              </label>
                                            </div>
                                          </>
                                        ) : optionone == "total" ? (
                                          <>
                                            <div className="form-check d-flex align-items-center mt-15 px-6">
                                              <Input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefaultdropd"
                                                id="ALL"
                                                onChange={
                                                  radioChangedroptotaldemand
                                                }
                                                defaultChecked="true"
                                                checked={
                                                  classcodetotaldemand == "ALL"
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                for="ALL"
                                              >
                                                All
                                              </label>
                                            </div>

                                            {isFB151 ? (
                                              <>
                                                {" "}
                                                <div class="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DKRP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DKRP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DKRP0"
                                                  >
                                                    Residential
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DKCP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DKCP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DKCP0"
                                                  >
                                                    Commercial
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DKDP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DKDP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DKDP0"
                                                  >
                                                    District Facility
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DICP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DICP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DICP0"
                                                  >
                                                    Irrigation
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DIDP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DIDP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DIDP0"
                                                  >
                                                    Tracking
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DISP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DISP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DISP0"
                                                  >
                                                    School Irrigation
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DKSP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DKSP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DKSP0"
                                                  >
                                                    School
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DKHP0"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DKHP0"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DKHP0"
                                                  >
                                                    HOA Facility
                                                  </label>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                {" "}
                                                <div class="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DICP1"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DICP1"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DICP1"
                                                  >
                                                    Potable Irrigation
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DKRP1"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DKRP1"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="PD"
                                                  >
                                                    Potable Domestic
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DFCP1"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DFCP1"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DFCP1"
                                                  >
                                                    Potable Fire
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="DICN1"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "DICN1"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="DICN1"
                                                  >
                                                    Non-Potable Supply
                                                  </label>
                                                </div>
                                                <div className="form-check d-flex align-items-center">
                                                  <Input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="flexRadioDefaultdropd"
                                                    id="I/C"
                                                    onChange={
                                                      radioChangedroptotaldemand
                                                    }
                                                    checked={
                                                      classcodetotaldemand ===
                                                      "I/C"
                                                    }
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    for="I/C"
                                                  >
                                                    Interconnect
                                                  </label>
                                                </div>
                                              </>
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <h5 className="mb-0">Account</h5>
                                    <h5 className="mb-0">Gallons</h5>
                                  </div>
                                  <div className="d-flex justify-content-between mt-2">
                                    <span className="text-blue fs-15">
                                      Total
                                    </span>
                                    <span className="text-blue fs-15">
                                      {response.total
                                        ? response.total
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )
                                        : 0}
                                    </span>
                                  </div>
                                  {/* {account?.map((person, index) => ( */}
                                  {response?.account_flow?.map(
                                    (person, index) => (
                                      <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
                                        <div className="d-flex w-100 pe-3">
                                          {status === true ? (
                                            ""
                                          ) : (
                                            <div
                                              style={{
                                                background: person.colour,
                                                width: "15px",
                                                height: "15px",
                                                marginRight: "15px",
                                              }}
                                            ></div>
                                          )}

                                          <p className="fs-15 mb-0 fw-semibold text-left w-100">
                                            {person?.account_name}
                                          </p>
                                        </div>
                                        <p className="fs-15 mb-0 fw-semibold w-100 text-end">
                                          {person.sum
                                            ? Number.parseFloat(person.sum)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )
                                            : 0}
                                        </p>
                                      </div>
                                    ),
                                  )}
                                </div>
                              ) : (
                                <div className="col-12 col-lg-3 trenddemand px-3">
                                  <div className="d-flex justify-content-between ">
                                    <h5 className="mb-0">Account</h5>
                                    <h5 className="mb-0">Gallons</h5>
                                  </div>
                                  <div className="d-flex justify-content-between mt-2">
                                    <span className="text-blue fs-15">
                                      Total
                                    </span>
                                    <span className="text-blue fs-15">
                                      {response.total
                                        ? response.total
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ",",
                                            )
                                        : 0}
                                    </span>
                                  </div>
                                  {response.account_flow?.map(
                                    (person, index) => (
                                      <div className="d-flex justify-content-between mt-3 px-2 bg-flow">
                                        <p className="fs-15 mb-0 text-left me-1">
                                          {person.account_name}
                                        </p>
                                        <p className="fs-15 mb-0">
                                          {person.sum
                                            ? Number.parseFloat(person.sum)
                                                .toString()
                                                .replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ",",
                                                )
                                            : 0}
                                        </p>
                                      </div>
                                    ),
                                  )}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </Card>
                </div>
                <br />
              </div>
            </div>
          </div>
          <br />
        </div>
      </Main>
    </>
  );
}

export default TotalFlow;
